module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<style>\n    .spl-form__page__result h3 {\n        font-weight : bold;\n        font-size   : 130%;\n    }\n\n    .spl-form__page__result table th {\n        font-weight : bold;\n    }\n\n    .spl-form__page__result table td, .spl-form__page__result table th {\n        padding : 5px;\n    }\n</style>\n<div class=\"form__page spl-form__page spl-form__page__result\">\n    <div>\n        <h3>Результат импорта</h3>\n\n        <table class=\"w100\">\n            <tr>\n                <th style=\"width: 30%\">Импортировано</th>\n                <td>")
    ; __append(escapeFn( _.get(widget, "result.objects.length") ))
    ; __append("</td>\n            </tr>\n            <tr>\n                <th>Ошибочных строк</th>\n                <td>")
    ; __append(escapeFn( _.get(widget, "result.errors.length") ))
    ; __append("</td>\n            </tr>\n            <tr>\n                <th colspan=\"2\">Список ошибочных строк</th>\n            </tr>\n            ")
    ;  _.each(_.get(widget, "result.errors") , function(error) { 
    ; __append("\n            <tr>\n                <td colspan=\"2\">")
    ; __append(escapeFn( error ))
    ; __append("</td>\n            </tr>\n            ")
    ;  }) 
    ; __append("\n        </table>\n    </div>\n</div>")
  }
  return __output.join("");

}